module.exports = __webpack_public_path__ + "img/iphone_2.171176c0.png";